import React from 'react';
import PropTypes from 'prop-types';
// import clsx from 'clsx';
// import {makeStyles} from '@material-ui/core/styles';
// import {amber, green} from '@material-ui/core/colors';
// import SnackbarContent from '@material-ui/core/SnackbarContent';
// import IconButton from '@material-ui/core/IconButton';
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import ErrorIcon from '@material-ui/icons/Error';
// import InfoIcon from '@material-ui/icons/Info';
// import CloseIcon from '@material-ui/icons/Close';
// import WarningIcon from '@material-ui/icons/Warning';
import PopoverFilterWrap from 'components/molecules/PopoverFilterWrap';
import MbRadioGroup from 'components/molecules/MbRadioGroup';

// const useStyles = makeStyles((theme) => ({}));

const Popover = (props) => {
  // const classes = useStyles();
  const {
    id,
    name,
    label,
    getOnClose,
    selectedLabel,
    filtered,
    filterType,
    filterList,
    optionSelectedValue,
    optionList,
    optionOnChange,
    children,
    ...rest
  } = props;

  return (
    <PopoverFilterWrap
      id={id}
      label={label}
      getOnClose={getOnClose}
      selectedLabel={selectedLabel}
      filtered={filtered}
      filterList={
        filterType === 'radio' ? (
          <MbRadioGroup
            selectedValue={optionSelectedValue}
            radioList={optionList}
            onChange={optionOnChange}
            name={name}
          />
        ) : (
          filterList
        )
        // filterType === 'checkbox' ? 'checkbox' : filterType === 'select' ? 'select':
      }
      {...rest}
    >
      {children}
    </PopoverFilterWrap>
  );
};

Popover.propTypes = {
  getOnClose: PropTypes.func,
  label: PropTypes.string,
  selectedLabel: PropTypes.string,
  filtered: PropTypes.bool,
  id: PropTypes.string,
  filterList: PropTypes.object,
  //     .isRequired,
};

export default Popover;
